import { LIABILITY_CONSTANTS } from '@flows/configs/liabilityNxt/constants'
import { DEDUCTIBLE_HEADER } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyNullableCustomComponent } from '@flows/core/types/CustomComponent'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'
import Schema_Quote from '@flows/insurance/schemas/shared/Schema_Quote'

const liability_quote = (params: StepConfigParams) => {
  const quoteStep = {
    type: 'customComponent',
    name: 'QuoteStep',
    props: {
      product: 'liability_v1_getsafe_de',
      configurableParameters: [
        DEDUCTIBLE_HEADER(),
        {
          type: 'dropDown',
          label: {
            type: 'translatableText',
            translationKey: 'sharedFlows_common:steps.deductibles',
          },
          useFilterInput: false,
          styleType: 'outlined',
          name: params.helperFunctions.getParamPath('deductible_amount'),
          options: LIABILITY_CONSTANTS.deductibleOptions.map((option): TransformedOption => {
            return {
              label: {
                type: 'nonTranslatableText',
                text: params.clientHelpers.formatter.formatCurrency(option),
              },
              value: Number(option),
            }
          }),
        },
      ] as const,
    },
    inputs: [],
    outputs: [],
  } as const satisfies AnyNullableCustomComponent
  return {
    validationStrategy: 'onChange',
    schema: Schema_Quote.merge(
      schemaUtils.generateZodObjectFromPaths({
        [params.helperFunctions.getParamPath('drones_coverage')]:
          BaseSchema_LiabilityV1GetsafeDe.shape.drones_coverage,
        [params.helperFunctions.getParamPath('family_coverage')]:
          BaseSchema_LiabilityV1GetsafeDe.shape.family_coverage,
        [params.helperFunctions.getParamPath('tariff_line')]:
          BaseSchema_LiabilityV1GetsafeDe.shape.tariff_line,
        [params.helperFunctions.getParamPath('deductible_amount')]:
          BaseSchema_LiabilityV1GetsafeDe.shape.deductible_amount,
      })
    ),
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
    nonStickyFooter: true,
    stepContent: [quoteStep],

    nextStep: 'emailAndName',
    subFlow: params.subFlow,
  } as const satisfies AnyStepConfiguration
}

export default liability_quote
